import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class TicketDetailBaseComponent extends BaseComponent {
  public text: string = "TicketDetail";

  constructor(userService: UserService) {
    super(userService);
  }
}
